export default __webpack_public_path__ + "5b19ef797043878479def292aafa541b.svg";